import { colors } from 'PDF/constants/colors';

type ColorsType = 'green' | 'blue' | 'red' | 'blueGreen' | 'blueRed' | 'blueYellow';

export const getColorType = () => (localStorage.getItem('documentColorType') as ColorsType) || 'green';

export const setColorType = (color: string) => localStorage.setItem('documentColorType', color);

export const getColorObjectStyle = (index: number, styleProperty: string) => {
  const type = getColorType();

  return { [styleProperty]: colors[type][index] };
};

export const getColorObjectStyleByRecord = (record: Record<ColorsType, number>, styleProperty: string) => {
  const type = getColorType();
  const colorIndex = record[type];

  return { [styleProperty]: colors[type][colorIndex] };
};

export const getColorObjectsStyle = (indexes: number[], styleProperties: string[]) => {
  const type = getColorType();

  return indexes.map((colorIndex, index) => ({ [styleProperties[index]]: colors[type][colorIndex] }));
};

export const getColorObjectsStyleByRecord = (indexes: Record<ColorsType, number[]>, styleProperties: string[]) => {
  const type = getColorType();

  return indexes[type].map((colorIndex, index) => ({ [styleProperties[index]]: colors[type][colorIndex] }));
};

export const getColorStyles = (indexes: number[]) => {
  const type = getColorType();

  return indexes.map((index) => colors[type][index]);
};
export const getColorStylesByRecord = (indexes: Record<ColorsType, number[]>) => {
  const type = getColorType();

  return indexes[type].map((index) => colors[type][index]);
};

export const getArrayOfColors = () => getColorStyles([12, 10, 1, 9, 14, 17, 15]);

export const getSecondArrayOfColors = () => getColorStyles([20, 11, 12, 21, 7, 13, 24, 16, 28, 19, 15, 26, 18, 22, 14]);
